<template>
  <div class="divPage">
    <div>
      <div class="orderTop">
        <b-row style="padding: 0 15px; font-size: 16px">
          <b-col> 订单状态：<span>等待申请人付款</span> </b-col>
        </b-row>
        <b-row class="topcol2">
          <b-col>
            您的图片已提交，请在24小时内完成支付，超时订单将自动取消
          </b-col>
        </b-row>
      </div>

      <div class="divItem">
        <h6>付款商品</h6>
        <hr />
        <b-row>
          <b-col>
            <img :src="thumbnailSrc" style="width: 64px" />
          </b-col>
          <b-col cols="6" class="rightText">卡面定制服务费x1<br /> </b-col>
          <!-- <b-col cols="4" class="rightText"
            >￥{{ orderInfoObj == null ? "" : orderInfoObj.price / 100 }}</b-col
          > -->
        </b-row>
      </div>
      <div class="divItem">
        <b-row>
          <b-col>
            <b-form-input
              v-model="voucherCode"
              id="input-voucher-code"
              type="text"
              placeholder="请输入优惠券码"
            ></b-form-input>
          </b-col>
        </b-row>
      </div>
      <div class="divItem">
        <h6>结算</h6>
        <hr />
        <b-row>
          <b-col class="rightText"
            >应付总额：￥{{
              orderInfoObj == null ? "" : orderInfoObj.price / 100
            }}</b-col
          >
        </b-row>
      </div>

      <div class="divItem">
        <h6>订单信息</h6>
        <hr />
        <b-row>
          <b-col
            >订单编号：<span>{{
              orderInfoObj == null ? "" : orderInfoObj.orderNo
            }}</span></b-col
          >
        </b-row>
        <b-row>
          <b-col
            >下单时间：<span>{{
              orderInfoObj == null ? "" : orderInfoObj.orderDateTime
            }}</span></b-col
          >
        </b-row>
      </div>

      <div class="divItemNotice">
        <div style="color: #777; font-size: 12px">
          <h6>温馨提示</h6>
          <div>1.支付后您将不能再更换卡片照片</div>
          <div>2.银行卡号为随机分配，一经生成无法更改</div>
          <div>
            3.我们将在20个工作日左右将卡片寄送到您指定的网点，请保持电话通畅
          </div>
        </div>

        <div class="divItem">
          <b-row>
            <b-col cols="10" class="mx-auto payBtn">
              <b-button block variant="primary" @click="wxPay()"
                >微信支付</b-button
              >
            </b-col>
            <b-col cols="10" class="mx-auto replaceBtn">
              <b-button block variant="primary" @click="replaceCardface()"
                >更改图片</b-button
              >
            </b-col>
          </b-row>
        </div>

        <!-- loading toast -->
        <div v-show="loading">
          <div class="weui-mask_transparent"></div>
          <div class="weui-toast">
            <i class="weui-loading weui-icon_toast"></i>
            <p class="weui-toast__content">下单中</p>
          </div>
        </div>

        <div v-show="showToast">
          <div class="weui-mask_transparent"></div>
          <div class="weui-toast">
            <p class="weui-toast__content">{{ toastMsg }}</p>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      ok-only
      ref="model_error"
      title="提示"
      @ok="handleOk"
      ok-title="确定"
    >
      <p class="my-4">{{ errorMsg }}</p>
    </b-modal>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import axios from "axios";
var config = require("../../common/config.js");
export default {
  name: "OrderPay_ql",
  data() {
    return {
      orderInfoObj: null,
      appid: "",
      code: "",
      thumbnailSrc: "", //图片
      loading: false,
      showToast: false,
      toastMsg: "",
      voucherCode: "",
      errorMsg: "",
      faceValue: "",
      practicalAmt: "",
      originalAmt: "",
    };
  },
  watch: {
    voucherCode: function (newval, oldval) {
      console.log("newval->", newval);
      console.log("oldval->", oldval);
      if (newval == "") {
        this.faceValue = "";
        this.practicalAmt = "";
        this.originalAmt = "";
      }

      console.log("faceValue->", this.faceValue);
    },
  },
  methods: {
    showToastMsg: function (msg) {
      this.toastMsg = msg;
      let that = this;
      that.showToast = true;
      setTimeout(function () {
        that.showToast = false;
      }, 2000);
    },
    showLoading: function () {
      this.loading = true;
    },
    hideLoading: function () {
      this.loading = false;
    },
    toOrderResult: function () {
      this.$router.replace({
        name: "OrderResult_ql",
        params: {
          orderNo: this.orderInfoObj.orderNo,
        },
      });
    },
    handleOk: function (bvModalEvt) {},
    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
    /* 
    @param voucherValue,优惠券面额
    @orderPrice 订单金额
     */
    caculatePriceWidthVoucher(voucherValue, orderPrice) {
      let price = orderPrice - voucherValue;
      if (price < 0) {
        return 0;
      }
      return price;
    },
    queryVoucher: function () {
      //检查优惠券
      var that = this;
      axios
        .get(config.config_ql.queryVoucher, {
          params: {
            bankCode: this.orderInfoObj.bankCode,
            voucherCode: this.voucherCode,
            cardTypeId: this.orderInfoObj.cardTypeId,
          },
        })
        .then(function (response) {
          console.log(response);
          var result = response.data;
          //{code: 103, message: "未找到对应的优惠券信息", faceValue: 0, practicalAmt: 0, originalAmt: 0}
          if (result.code == 0) {
            that.faceValue = result.faceValue;
            // that.practicalAmt = result.practicalAmt;
            // that.originalAmt = result.originalAmt;
            let price = that.caculatePriceWidthVoucher(
              result.faceValue,
              that.orderInfoObj.price
            );
            that.unifyOrderWithVoucher(price);
          } else {
            that.errorMsg = result.message;
            that.showErrorMsg();
          }
        })
        .catch(function (error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
        });
    },
    //微信支付
    wxPay: function () {
      // this.toOrderResult()//测试直接跳转
      if (this.voucherCode == "") {
        this.unifyOrder();
      } else {
        this.queryVoucher();
      }
    },
    //更改图片
    replaceCardface: function () {
      this.$store.commit("ql/reuploadImg");
      var param = {
        isModify: 1,
        orderNo: this.orderInfoObj.orderNo,
        backgroundColor: this.orderInfoObj.backgroundColor,
        isPayed: false,
      };
      console.log(`param`, param);
      var selectParam = JSON.stringify(param);
      console.log("selectParam:" + selectParam);
      this.$router.push({
        name: "SelectCardface_ql",
        params: {
          selectParam: selectParam,
        },
      });
    },
    starToPay: function (payargs) {
      console.log("======starToPay======");
      var that = this;
      wx.chooseWXPay({
        timestamp: payargs.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: payargs.nonceStr, // 支付签名随机串，不长于 32 位
        package: payargs.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: payargs.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: payargs.sign, // 支付签名
        success: function (res) {
          // 支付成功后的回调函数
          console.log("支付成功" + res);
          that.toOrderResult();
        },
        // 支付取消回调函数
        cencel: function (res) {
          console.log(res);
        },
        // 支付失败回调函数
        fail: function (res) {
          console.log(res);
        },
      });
    },
    wxJsSdk: function () {
      var that = this;
      var url = window.location.href.split("#")[0];
      var formData = new FormData();
      formData.append("shareUrl", url);
      formData.append("bankCode", "default");
      formData.append("type", "1");
      axios({
        method: "post",
        url: config.config_ql.initWXJSSDKConfigInfo,
        data: formData,
      })
        .then(function (response) {
          var result = response.data;
          if (result.code != 0) {
            //失败
            that.errorMsg = "获取appID失败";
            that.showErrorMsg();
            return;
          }
          let data = result.data;
          that.appid = data.appid;
          console.log(data.appid);
          console.log(response.data);
          console.log(response.status);
          console.log(response.statusText);
          console.log(response.headers);
          console.log(response.config);

          /* {
                signature: "1ba9d96ab3b38bb34037b46d5714d61b659d3031",
                appid: "wxecacb5516c17832b",
                jsapi_ticket: "kgt8ON7yVITDhtdwci0qeR5ZO1LunrcgBtLGj8xD8npFwV-6wRlIWdgjZMmuTynPLmFHHz7E30LFBGwzmBtLOg",
                nonceStr: "6024281b-1600-4960-81b6-87876c9203b4",
                timestamp: "1589963929"
              } */

          wx.config({
            debug: false,
            appId: data.appid,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ["chooseWXPay"],
          });
          // that.checkOpenid();
          wx.ready(function () {
            that.checkOpenid();
          });
          wx.error(function (res) {
            console.log(res);
          });
        })
        .catch(function (error) {
          console.log(error);
          that.errorMsg = `${error.message}`;
          that.showErrorMsg();
        });
    },
    checkOpenid: function () {
      console.log("=========checkOpenid=========");
      let that = this;

      var openid = sessionStorage.getItem("openid");
      var code = this.getUrlParam("code"); // 截取code
      this.code = code;

      console.log("openid:" + openid);
      console.log("code:" + code);
      console.log("code is empty + " + (code == ""));

      if (openid == undefined) {
        if (this.code == "") {
          this.getCode();
        } else {
          var myObj = {
            code: this.code,
            bankCode: "default",
            type: "1",
          };
          axios
            .post(config.config_ql.getJSAPIOpenid, myObj)
            .then(function (response) {
              /* {
                    access_token: "33_ydBrI6lMSAVfEZWX5Q7Kw30jbuTiTCOrca_hPDU3g53tE7drWJRnOteLtPrmtKcFz3gBBL1RhpgefRrBKWQNug"
                    expires_in: 7200
                    openid: "oVdoHv2bVEk5wtyyHAf_Y6cjZZPw"
                    refresh_token: "33_0iS-3XElEHIpcZhmcaaPZl8xTkXnY1O1Zv6NTndAth9ro_srWEeuInDeoNcnR1F70fgCgENZmAcJt1o7YmVi3A"
                    scope: "snsapi_base"
                  } */
              console.log(response);
              var result = response.data;
              if (result.code != 0) {
                that.errorMsg = "获取openID失败";
                that.showErrorMsg();
                return;
              }
              let data = result.data;
              var openid = data.openid;
              sessionStorage.setItem("openid", openid);
              that.$router.go(-1);
              //FIX ios x, 11 不能调起微信支付问题
              that.$router.go(0);
            })
            .catch(function (error) {
              console.log(error);
              that.errorMsg = `${error.message}`;
              that.showErrorMsg();
            });
        }
      } else {
      }
    },
    getCode: function () {
      var url = "https://open.weixin.qq.com/connect/oauth2/authorize?";
      var appid = "appid=" + encodeURIComponent(this.appid);
      var redirect_uri =
        "&redirect_uri=" + encodeURIComponent(window.location.href);
      var response_type = "&response_type=" + encodeURIComponent("code");
      //静默获取code
      var scope = "&scope=" + encodeURIComponent("snsapi_base");
      //需要用户授权获取code
      //var scope = "&scope=" + encodeURIComponent("snsapi_userinfo");
      var state = "&state=" + encodeURIComponent("123");
      var wechat_redirect = "#wechat_redirect";

      var targetUrl =
        url +
        appid +
        redirect_uri +
        response_type +
        scope +
        state +
        wechat_redirect;

      //window.location.href = targetUrl;
      window.location.replace(targetUrl);
    },
    getUrlParam: function (variable) {
      var query = window.location.search.substring(1);
      console.log("url search param:" + query);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return decodeURIComponent(pair[1]);
        }
      }
      return "";
    },
    //统一下单接口，用优惠后的价格下单
    unifyOrderWithVoucher: function (discountedPrice) {
      var that = this;
      var openid = sessionStorage.getItem("openid");
      if (openid == undefined) {
        return;
      }

      var myObj = {
        hbTradeType: 1,
        openid: openid,
        order_id: this.orderInfoObj.orderNo,
        total_fee: discountedPrice,
        pay_source: this.orderInfoObj.projectName,
        bankCode: this.orderInfoObj.bankCode,
        deadline: this.orderInfoObj.deadline, //支付截至日期
        voucherCode: this.voucherCode, //电子券
        faceValue: this.faceValue,
        // practicalAmt: this.practicalAmt,
        orderAmt: this.orderInfoObj.price,
        appid: this.appid,
      };

      console.log(JSON.stringify(myObj));
      that.showLoading();

      axios
        .post(config.config_ql.unifiedOrder, myObj)
        .then(function (response) {
          that.hideLoading();
          console.log(response);
          var data = response.data;
          if (data.code == 0) {
            var payargs = data.data;
            console.log(payargs);
            if (payargs == undefined) {
              //优惠券金额与制卡费用相等，无需支付，直接跳转到订单结果页面
              that.toOrderResult();
            } else {
              //需要支付
              that.starToPay(payargs);
            }
          } else {
            that.errorMsg = data.msg;
            that.showErrorMsg();
            //that.showToastMsg(data.message);
          }
        })
        .catch(function (error) {
          that.hideLoading();
          console.log(error);
          that.errorMsg = `${error.message}`;
          that.showErrorMsg();
        });
    },

    //微信支付
    unifyOrder: function () {
      console.log("1", 1);
      var that = this;
      var openid = sessionStorage.getItem("openid");
      if (openid == undefined) {
        return;
      }

      var myObj = {
        hbTradeType: 1,
        openid: openid,
        order_id: this.orderInfoObj.orderNo, //订单编号
        total_fee: this.orderInfoObj.price, //应付总额
        pay_source: this.orderInfoObj.projectName, //diy
        bankCode: this.orderInfoObj.bankCode, //银行编号
        deadline: this.orderInfoObj.deadline, //支付截至日期
        voucherCode: this.voucherCode, //电子券
        faceValue: this.faceValue,
        // practicalAmt: this.practicalAmt,
        orderAmt: this.orderInfoObj.price,
        appid: this.appid,
      };

      console.log(JSON.stringify(myObj));
      that.showLoading();

      axios
        .post(config.config_ql.unifiedOrder, myObj)
        .then(function (response) {
          that.hideLoading();
          console.log(response);
          var data = response.data;
          if (data.code == 0) {
            var payargs = data.data;
            console.log(payargs);
            that.starToPay(payargs);
          } else {
            that.errorMsg = data.msg;
            that.showErrorMsg();
            //that.showToastMsg(data.message);
          }
        })
        .catch(function (error) {
          that.hideLoading();
          console.log(error);
          that.errorMsg = `${error.message}`;
          that.showErrorMsg();
        });
    },
  },
  beforeRouteLeave(to, from, next) {
    console.log("to", to);
    console.log("from", from);
    if (from.name == "OrderResult_ql") {
      console.log(`12333`, 12333);
      this.$router.push({
        path: "selectCardface_ql",
      });
    }
    next();
  },
  mounted: function () {
    /* {
           orderNo: '01248790113566597120',
           orderDateTime: '2020-05-22 09:39:22',
           price: 1,
           projectName: 'DIY',
           thumbnailFileUrl: ''
         } */
    console.log("this.$route.params", this.$route.params);
    var orderInfo = this.$route.params.orderInfo;
    if (orderInfo !== undefined) {
      this.orderInfoObj = JSON.parse(orderInfo);
      sessionStorage.setItem("orderInfo", orderInfo);
    } else {
      var orderInSession = sessionStorage.getItem("orderInfo");
      this.orderInfoObj = JSON.parse(orderInSession);
    }

    console.log("数据>>", this.orderInfoObj);
    this.thumbnailSrc =
      config.config_ql.baseImgUrl + this.orderInfoObj.thumbnailFileUrl;
    console.log("thumbnailSrc:" + this.thumbnailSrc);

    this.wxJsSdk();
  },
};
</script>

<style scoped>
.payBtn {
  margin-top: 5px;
  background: #fff;
}

.replaceBtn {
  background: #fff;
  margin-top: 10px;
  margin-bottom: 5px;
}

.divItem {
  margin-top: 5px;
  background-color: white;
  padding: 5px;
}

.divItemNotice {
  margin-top: 16px;
  padding: 8px;
}

.rightText {
  text-align: right;
}

.divPage {
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-color: #f1f2f3;
}

.orderTop {
  background: #666;
  margin-top: 0;
  color: #fff;
  padding: 3px;
  font-size: 14px;
}

.orderTop .topcol2 {
  font-size: 14px;
  padding-bottom: 15px;
  padding-top: 5px;
  padding-left: 15px;
  padding-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/qilubank/OrderPay_ql.vue